const BASE_SLOTS = [
  { key: 'frente', labelKey: 'progress_photos.slot_front', fallback: 'Frente' },
  { key: 'lateral', labelKey: 'progress_photos.slot_side', fallback: 'Lateral derecha' },
  { key: 'espalda', labelKey: 'progress_photos.slot_back', fallback: 'Espalda' },
  { key: 'detalle', labelKey: 'progress_photos.slot_detail', fallback: 'Lateral izquierdo' },
];

const PHASES = [
  { phase: 'inicio', labelKey: 'progress_photos.phase_start', fallback: 'Inicio de ciclo' },
  { phase: 'fin', labelKey: 'progress_photos.phase_end', fallback: 'Fin de ciclo' },
];

function slotName(key, phase) {
  return `${key}_${phase}`;
}

export const PROGRESS_PHOTO_SLOT_PHASES = PHASES.map((p) => ({
  ...p,
  slots: BASE_SLOTS.map((b) => ({
    slot: slotName(b.key, p.phase),
    labelKey: b.labelKey,
    fallback: b.fallback,
    phase: p.phase,
    base: b.key,
  })),
}));

export const PROGRESS_PHOTO_SLOTS = PROGRESS_PHOTO_SLOT_PHASES.flatMap((g) => g.slots);

/** Slots legacy (sin fase) → inicio de ciclo. */
export const LEGACY_SLOT_TO_INICIO = Object.fromEntries(
  BASE_SLOTS.map((b) => [b.key, slotName(b.key, 'inicio')]),
);

export function normalizePhotoSlot(slot) {
  const s = String(slot || '').trim();
  if (!s) return null;
  if (LEGACY_SLOT_TO_INICIO[s]) return LEGACY_SLOT_TO_INICIO[s];
  return s;
}

export function isFinPhaseSlot(slot) {
  return String(slot || '').endsWith('_fin');
}

export const FIN_TO_INICIO_SLOT = Object.fromEntries(
  BASE_SLOTS.map((b) => [slotName(b.key, 'fin'), slotName(b.key, 'inicio')]),
);
